import { EmptyCoroutineContext_instance2qpebg1xogbvt as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Key_getInstance2js7sv2agqob1 as Key_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import {
  CoroutineStart_DEFAULT_getInstance2bbgmtawlnkke as CoroutineStart_DEFAULT_getInstance,
  CoroutineStart_UNDISPATCHED_getInstance1s89xhsoy2cne as CoroutineStart_UNDISPATCHED_getInstance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Key_instance6wd16m35aua5 as Key_instance } from '../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
} from '../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ReactiveLoadings35224pps2d9 as ReactiveLoading } from '../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function load(_this__u8e3s4, context, action) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  var state = RawReactive().yah();
  var tmp;
  var tmp0_safe_receiver = _this__u8e3s4.ea2().cd(Key_getInstance());
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qa8(_this__u8e3s4.ea2())) === false) {
    tmp = CoroutineStart_UNDISPATCHED_getInstance();
  } else {
    tmp = CoroutineStart_DEFAULT_getInstance();
  }
  var tmp1_start = tmp;
  var result = launch(_this__u8e3s4, context, tmp1_start, load$slambda_0(action, state));
  var tmp2_safe_receiver = _this__u8e3s4.ea2().cd(Key_instance);
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.cah(state);
  }
  return result;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.core.reactiveState' call
  var tmp;
  try {
    var tmp_0 = $this.tcx_1($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = _ReactiveState___init__impl__fvdp9b(Unit_instance);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException()) {
      var _unused_var__etf5q3 = $p;
      tmp_1 = Companion_getInstance().mah_1;
    } else {
      if ($p instanceof ReactiveLoading()) {
        var _unused_var__etf5q3_0 = $p;
        tmp_1 = Companion_getInstance().mah_1;
      } else {
        if ($p instanceof Exception()) {
          var e = $p;
          tmp_1 = Companion_getInstance().uah(e);
        } else {
          throw $p;
        }
      }
    }
    tmp = tmp_1;
  }
  var r = tmp;
  $this.ucx_1.pah(r);
  return Unit_instance;
}
var load$slambdaClass;
function load$slambda() {
  if (load$slambdaClass === VOID) {
    class $ {
      constructor($action, $state) {
        this.tcx_1 = $action;
        this.ucx_1 = $state;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    load$slambdaClass = $;
  }
  return load$slambdaClass;
}
function load$slambda_0($action, $state) {
  var i = new (load$slambda())($action, $state);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  load as loadwmtw2477i8f8,
};
//endregion

//# sourceMappingURL=lightweightSuspension.mjs.map
